import React from 'react';
import clsx from 'clsx';
import TextField from '@material-ui/core/TextField';
import { Autocomplete, Input } from '@shared/components';

import useStyle from './styles';

const defaultState = {
  error: null,
};

const noop = () => {};

export default ({
  row = {},
  element = {},
  error = null,
  section = null,
  rowsCount = null,
  errorsCount = null,
  onChange = noop,
  getFieldOptions = noop,
}) => {
  const classes = useStyle();

  const [state, setState] = React.useState(defaultState);

  React.useEffect(() => {
    if (section) {
      setState(prevState => ({
        ...prevState,
        [element.dbFieldName]: row[element.dbFieldName],
        error,
      }));
    }
  }, [section, rowsCount, errorsCount]);

  return element.isDropdown ? (
    <Autocomplete
      fullWidth
      wrapperClassName='input-grid-field'
      classes={{
        root: 'd-flex',
        paper: [classes.optionsList],
      }}
      disableClearable
      getOptionLabel={option => {
        return (
          option.label ||
          option.name ||
          option.title ||
          option.friendlyName ||
          option.displayName ||
          (typeof option === 'boolean' ? (option ? 'Y' : 'N') : option)
        );
      }}
      value={
        typeof state[element.dbFieldName] === 'boolean'
          ? state[element.dbFieldName]
            ? 'Y'
            : 'N'
          : state[element.dbFieldName] || null
      }
      options={getFieldOptions(element.dbFieldName, row, element.type) || []}
      onChange={async (event, selectedOption) => {
        const value = selectedOption.value;
        await onChange(
          row.rowIndexId,
          section,
          element.dbFieldName,
          value,
          true,
          true,
          true
        );
        setState(prevState => ({
          ...prevState,
          [element.dbFieldName]: value,
          error: null,
        }));
      }}
      renderInput={params => {
        return (
          <TextField
            {...params}
            margin='dense'
            classes={{
              ...params.classes,
              root: `input-field ${params.classes?.root}`,
            }}
            error={!!state.error}
            variant='outlined'
            helperText={state.error ? state.error : ''}
          />
        );
      }}
    />
  ) : (
    <Input
      value={state[element.dbFieldName]}
      hasError={state.error}
      helperText={state.error ? state.error : ''}
      wrapperClassName='input-grid-field'
      onChange={event => {
        const value = event.currentTarget.value;
        setState(prevState => ({
          ...prevState,
          [element.dbFieldName]: value,
        }));
        onChange(
          row.rowIndexId,
          section,
          element.dbFieldName,
          value,
          false,
          true
        );
      }}
      onBlur={event => {
        setState(prevState => ({
          ...prevState,
          error: null,
        }));
        onChange(
          row.rowIndexId,
          section,
          element.dbFieldName,
          null,
          true,
          false
        );
      }}
    />
  );
};
